<!-- Card -->
<section class="card">
  <!-- Header -->
  <div class="card-header">
    <h3 class="card-title">
      {{ 'activityModule.activities' | translate }}
    </h3>
  </div>
  <!-- End Header -->

  <!-- Body -->

  <activity-table
    [tableData]="activities$ | async"
    (onClickRow)="onClickRow($event)"
  ></activity-table>

  <!-- End Body -->
</section>
<!-- End Card -->
